import { useGate } from 'statsig-react';
import { gql } from '@soundxyz/gql-string';
import type { OnData } from '@soundxyz/graphql-react-ws';
import type { Maybe } from '@soundxyz/utils';
import { useSubscription } from '@graphql/graphql-ws';
import { NewActivitiesDocument } from '@graphql/reactQuery';
import { FEATURE_GATES } from '@utils/constants';

/*#__PURE__*/ gql(/* GraphQL */ `
  subscription NewActivities($activityFeedId: UUID!) {
    activityFeedNewGroup(activityFeedId: $activityFeedId) {
      activityFeedGroupInformationTypename
    }
  }
`);

export function useActivityFeedSubscription({
  activityFeedId,
  onSubscriptionData,
}: {
  activityFeedId: Maybe<string>;
  onSubscriptionData: OnData<typeof NewActivitiesDocument>;
}) {
  const { value } = useGate(FEATURE_GATES.ACTIVITY_FEED_SUBSCRIPTIONS);

  useSubscription({
    query: NewActivitiesDocument,
    variables: !!activityFeedId && {
      activityFeedId,
    },
    onData: onSubscriptionData,
    enabled: value,
  });
}
